import Model, { attr, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type PcsCompanyModel from './pcs-company';
import type PcsProviderModel from './pcs-provider';
import type PcsProviderLoadModel from './pcs-provider-load';

export default class PcsCompanyLoadModel extends Model {
  @attr declare actual: number;
  @attr declare amount: number;
  @attr declare cover: number;
  @attr declare provider: string;
  @attr declare providerId: string;
  @attr declare providerData: Record<string, unknown>;
  @attr declare state: string;
  @attr declare transitionLog: Record<string, unknown>;

  /*************************
   **  Relationships      **
   *************************/

  @belongsTo('pcs-company', { async: false, inverse: null })
  declare pcsCompany: PcsCompanyModel;

  @belongsTo('pcs-provider', { async: false, inverse: null })
  declare pcsProvider: PcsProviderModel;

  @belongsTo('pcs-provider-load', { async: false, inverse: 'pcsCompanyLoads' })
  declare pcsProviderLoad: PcsProviderLoadModel | null;

  [Type] = 'pcs-company-load' as const;
}
